import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

const bounce = keyframes`
  0%, 30% {
    transform: translateY(0);
  }
  60% {
    transform: translateY(-33px);
  }
`;

const Dot = styled.div`
  animation: ${bounce} 1.2s infinite;
  background: linear-gradient(143.3deg, #25A2FA 6.21%, #0075FF 52.04%, #3F58EA 100.94%);
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
  height: 24px;
  margin: 0;
  width: 24px;
`;

const MemoizedDot = memo(Dot);

const Container = styled.div<{size?: number}>`
  align-items: center;
  display: flex;
  gap: 1rem;
  height: ${props => props?.size ?? '100'}px;
  justify-content: center;
  width: ${props => props?.size ?? '100'}px;  

  & > div:nth-child(1) { animation-delay: 0.2s; }
  & > div:nth-child(2) { animation-delay: 0.4s; }
  & > div:nth-child(3) { animation-delay: 0.6s; }
`;

export const Spinner = ({ size = 100 }) => (
  <Container size={size}>
    <MemoizedDot />
    <MemoizedDot />
    <MemoizedDot />
  </Container>
);

Spinner.propTypes = {
  size: PropTypes.number,
};

Spinner.defaultProps = {
  size: 100,
};
